import type { SectionProps } from "../types";
import { audience } from "../data";

export default function AudienceSection({ isVisible, sectionRef }: SectionProps) {
  return (
    <section
      ref={sectionRef}
      data-section="audience"
      className="py-16 sm:py-20 md:py-24 bg-gray-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div
          className={`text-center mb-10 sm:mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
          }`}
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-[#2a4b7c] mb-3 sm:mb-4 px-4">
            Ai Phù Hợp Với Stackway Academy?
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            Chương trình của chúng tôi được thiết kế cho nhiều đối tượng khác nhau
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-6">
          {audience.map((item, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl p-4 sm:p-5 md:p-6 border-2 border-gray-100 hover:border-cyan-500 transition-all duration-700 hover:shadow-xl cursor-pointer ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-cyan-100 rounded-lg mb-3 sm:mb-4">
                <i className={`${item.icon} text-2xl sm:text-3xl text-cyan-600`}></i>
              </div>
              <h3 className="text-sm sm:text-base md:text-lg font-bold text-[#2a4b7c] mb-1.5 sm:mb-2">
                {item.title}
              </h3>
              <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

